import { useQuery, useMutation } from '@tanstack/react-query';
import { AgentsAPI } from '@newo/api/gateway';
import type { TAgentData } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const agentsAPI = new AgentsAPI(axios);

// GET Agent
export const useAgentQuery = (agentId?: string) =>
    useQuery({
        queryKey: ['agent', agentId],
        queryFn: async () => {
            if (!agentId) {
                throw new Error('Invalid agentId');
            }
            return agentsAPI.getAgent(agentId);
        },
        enabled: Boolean(agentId)
    });

// CREATE Agent
export const useCreateAgentMutation = () =>
    useMutation({
        mutationFn: async ({
            projectId,
            data
        }: {
            projectId: string;
            data: TAgentData;
        }) => agentsAPI.createAgent(projectId, data)
    });

// UPDATE Agent
export const useUpdateAgentMutation = () =>
    useMutation({
        mutationFn: async ({
            agentId,
            data
        }: {
            agentId: string;
            data: Partial<TAgentData>;
        }) => agentsAPI.updateAgent(agentId, data)
    });

// DELETE Agent
export const useDeleteAgentMutation = () =>
    useMutation({
        mutationFn: async ({ agentId }: { agentId: string }) =>
            agentsAPI.deleteAgent(agentId)
    });
